import authstore from '@/store/modules/auth';
import { clients } from '@/services/client.factory'


const categoryGroups = {
    namespaced: true,
    state: {
        item: null,
        items: [],
        error: null,
        errors: {},
    },
    getters: {
        item: (state) => state.item,
        items: (state) => state.items,
        error: (state) => state.error,
        errors: (state) => state.errors,
    },
    mutations: {
        CATEGORY_GROUP_SET_ITEM(state, item) {
            Object.assign(state, { item })
        },
        CATEGORY_GROUP_CREATE_ITEM(state, item) {
            state.items.push(item);
        },
        CATEGORY_GROUP_UPDATE_ITEM(state, item) {
            state.item = Object.assign({}, state.item, item)
        },
        CATEGORY_GROUP_SET_ITEMS(state, items) {
            Object.assign(state, { items })
        },
        CATEGORY_GROUP_SET_ERROR(state, error) {
            Object.assign(state, { error })
        },
        CATEGORY_GROUP_SET_ERRORS(state, errors) {
            Object.assign(state, { errors })
        },
        CATEGORY_GROUP_REMOVE_ITEM(state, item) {
            const index = state.items.findIndex(i => i.id === item.id);
            state.items.splice(index, 1);
        }
    },
    actions: {
        getItem(context, id) {
        },
        async getItems({ commit }) {
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            
            await clients.placeServiceClient.getCategoryGroups(jwt.city_code)
                .then((res) =>res.data)
                .then((data) =>
                    commit('CATEGORY_GROUP_SET_ITEMS', data)
                )
        },
        async addCategoryGroup({ commit }, category) {
            console.log("create")
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            await clients.placeServiceClient.addCategoryGroup({cityCode:jwt.city_code, name:category.name, icon:category.icon})
            commit('CATEGORY_GROUP_CREATE_ITEM', category);

        },
        update(context) {
        },
        async removeCategory({ commit }, category) {
            await clients.placeServiceClient.deleteCategory(category.item.id);
            //commit('CATEGORY_GROUP_REMOVE_ITEM', category.item);
        }
    }
}

export default categoryGroups;